// src/Dashboard/pages/teacher/AttendanceTable/components/AttendanceMonthToolbar.jsx

import React from "react";
import {
  FaChartBar,
  FaChevronLeft,
  FaLayerGroup,
  FaRegCalendarAlt,
} from "react-icons/fa";

export default function AttendanceMonthToolbar({
  groups = [],
  months = [],
  selectedGroup,
  selectedGroupId,
  selectedMonth,
  loading,
  onSelectGroup,
  onSelectMonth,
  onShowGroupPicker,
  showCharts,
  onToggleCharts,
}) {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div className="min-w-0">
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Groupe sélectionné
            </p>

            <h2 className="mt-1 truncate text-xl font-bold text-slate-900 dark:text-white">
              {selectedGroup?.nom || "Groupe"}
            </h2>

            <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
              Choisissez le mois à consulter ou changez de groupe.
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <button
              type="button"
              onClick={onShowGroupPicker}
              className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
            >
              <FaChevronLeft />
              Groupes
            </button>

            <button
              type="button"
              onClick={onToggleCharts}
              className={`inline-flex items-center gap-2 rounded-2xl px-4 py-3 text-sm font-bold transition ${
                showCharts
                  ? "bg-[#013E8E] text-white hover:bg-indigo-800"
                  : "border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
              }`}
            >
              <FaChartBar />
              Graphiques
            </button>
          </div>
        </div>

        <div className="mt-5 grid gap-3 md:grid-cols-2">
          <div>
            <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
              Groupe
            </label>

            <div className="relative">
              <FaLayerGroup className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />

              <select
                value={selectedGroupId}
                onChange={(event) => onSelectGroup?.(event.target.value)}
                disabled={loading}
                className="w-full appearance-none rounded-2xl border border-slate-200 bg-slate-50 py-3 pl-11 pr-4 text-sm font-bold text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
              >
                {groups.map((group) => (
                  <option key={group.id} value={String(group.id)}>
                    {group.nom}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div>
            <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
              Mois
            </label>

            <div className="relative">
              <FaRegCalendarAlt className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />

              <select
                value={selectedMonth}
                onChange={(event) => onSelectMonth?.(event.target.value)}
                disabled={loading}
                className="w-full appearance-none rounded-2xl border border-slate-200 bg-slate-50 py-3 pl-11 pr-4 text-sm font-bold text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
              >
                <option value="">Sélectionnez un mois</option>

                {months.map((month) => (
                  <option key={month.value} value={month.value}>
                    {month.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}